/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Hamburger/theme';

export const HamburgerTheme = theme;
